import React, { useState } from 'react';
import { db } from '../firebase';
import {
  collection,
  doc,
  addDoc,
  getDoc,
  updateDoc,
  deleteDoc,
} from 'firebase/firestore';

const FirebaseTestPage = () => {
  const testDocId = 'OfjwHCeE2LSk88cZD3jf'; // 🔁 테스트할 문서 ID로 교체
  const [docData, setDocData] = useState<any | null>(null);

  // 🔸 CREATE
  const createDocument = async () => {
    try {
      const docRef = await addDoc(collection(db, 'applications'), {
        user_name: '테스트 사용자',
        phone_number: '01012345678',
        device_type: '아이폰',
        device_model: 'iPhone 13 Pro',
        agreed_to_privacy: true,
        auth_verified: true,
        status: '신청완료',
        created_at: new Date(),
        updated_at: new Date(),
      });
      console.log('✅ 문서 생성 성공:', docRef.id);
    } catch (error) {
      console.error('❌ 문서 생성 실패:', error);
    }
  };

  // 🔸 READ
  const readDocument = async (docId: string) => {
    try {
      const docRef = doc(db, 'applications', docId);
      const snapshot = await getDoc(docRef);
      if (snapshot.exists()) {
        console.log('✅ 문서 데이터:', snapshot.data());
        setDocData(snapshot.data()); // ✅ 상태 저장
      } else {
        console.log('❗ 문서가 존재하지 않습니다.');
        setDocData(null);
      }
    } catch (error) {
      console.error('❌ 문서 조회 실패:', error);
    }
  };

  // 🔸 UPDATE
  const updateDocument = async (docId: string) => {
    try {
      await updateDoc(doc(db, 'applications', docId), {
        status: '검수중',
        updated_at: new Date(),
      });
      console.log('✅ 문서 업데이트 성공');
    } catch (error) {
      console.error('❌ 문서 업데이트 실패:', error);
    }
  };

  // 🔸 DELETE
  const deleteDocument = async (docId: string) => {
    try {
      await deleteDoc(doc(db, 'applications', docId));
      console.log('🗑️ 문서 삭제 성공');
      setDocData(null);
    } catch (error) {
      console.error('❌ 문서 삭제 실패:', error);
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>📦 Firebase Firestore CRUD 테스트</h2>
      <button onClick={createDocument}>CREATE 문서</button>
      <button onClick={() => readDocument(testDocId)}>READ 문서</button>
      <button onClick={() => updateDocument(testDocId)}>UPDATE 문서</button>
      <button onClick={() => deleteDocument(testDocId)}>DELETE 문서</button>

      {docData && (
        <div style={{ marginTop: '2rem', padding: '1rem', border: '1px solid #ddd', borderRadius: 8 }}>
          <h3>📄 문서 데이터</h3>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {JSON.stringify(docData, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default FirebaseTestPage;
